import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';

import componentStyles from './pc-contact-card.css.lit';

/**
 * Contact card component
 * @element pc-contact
 * @slot - This element has a default slot
 */
@customElement('pc-contact-card')
export class PCContactCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="contact-card">
        <div class="image"><slot name="image"></slot></div>
        <div class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-contact-card': PCContactCard;
  }
}
